// Belopp i öre som kronor, som i designen Web-Betalning: "2 490 kr" och
// "3 112,50 kr". Ören visas bara när de finns.
const kronor = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 });

export function krMedOre(ore: number): string {
  const hela = Math.floor(ore / 100);
  const rest = ore % 100;
  return `${kronor.format(hela)}${rest ? `,${String(rest).padStart(2, '0')}` : ''} kr`;
}
